import { render } from "./MapMigrateConfiger.vue?vue&type=template&id=b1fa8934&scoped=true"
import script from "./MapMigrateConfiger.vue?vue&type=script&lang=js"
export * from "./MapMigrateConfiger.vue?vue&type=script&lang=js"

import "./MapMigrateConfiger.vue?vue&type=style&index=0&id=b1fa8934&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1fa8934"]])

export default __exports__